/**
 * Componente que se encarga de recibir las peticiones enviadas desde las pqr
 * con el fin de recargar la vista.
 * JMM-2018-07-24
 */
import { Component, OnInit } from '@angular/core';
//Enrutamiento
import { Router, ActivatedRoute } from '@angular/router';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';

@Component({
  selector: 'app-enrutamientopqr',
  templateUrl: './enrutamientopqr.component.html',
  styleUrls: ['./enrutamientopqr.component.css']
})
export class EnrutamientopqrComponent implements OnInit {

  constructor(
    private route   : ActivatedRoute,
    private router  : Router,
    private http    : Http
  ) {}

  /**
   * Dentro de esta función se manejan los enrutamientos automáticos
   * hacia donde se enrutan las peticiones del componente.
   * JMM-2018-07-24
   */
  ngOnInit() 
  {
    let identificador = this.route.snapshot.paramMap.get('id');

    if (identificador == 'pagepqr') {
      this.router.navigate(['/main/pqr'], { replaceUrl: true });
    }

    if (identificador != 'pagepqr') {
      this.router.navigate(['/main/pqr/tratamiento-pqr/'+identificador], { replaceUrl: true });
    }
  }// .ngOnInit() 

}



// WEBPACK FOOTER //
// E:/xampp/htdocs/liberado/CocoraSMFront/src/app/main/enrutamientos/enrutamientopqr/enrutamientopqr.component.ts